import * as React from "react";

export default function Landing() {
  return (
    <div>
      <h1 className="text-4xl	mr-96 size-4/12	 mt-48 text-white">Welcome to MixCodes Portal. Please use the menus above to get started</h1>
    </div>
  );
}
